import React from 'react'
import {makeStyles} from '@material-ui/styles'

const useStyles = makeStyles({
  root: {
    textAlign: 'center',
    display: 'flex',
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
  },
  wrapper: {
    minWidth: '300px',
    margin: 'auto',
  },
})

export default function Wrapper(props) {
  const {root, wrapper} = useStyles()
  return (
    <div className={root}>
      <div className={wrapper} {...props} />
    </div>
  )
}